import { type QueryClient } from "@tanstack/react-query";

import { requireMe } from "udzs-common/auth";

import { pipAuthClient, pipMeApi } from "./client";

export function requirePipMe(request: Request, queryClient: QueryClient) {
  return requireMe({
    request,
    authClient: pipAuthClient,
    queryClient,
    meApi: pipMeApi,
  });
}
